<template>
    <rkm-overlay>
        <rkm-layout-body title="Atendimento domiciliar">
            <template v-slot:actions>
                <rkm-button
                    color="primary"
                    @click="$router.push({ name: 'atencao-basica-atendimento-domiciliar-create' })"
                >
                    Novo Atendimento
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/atencao-basica/atendimento-domiciliar/List'

export default {
    components: { List },
}
</script>